import { render, staticRenderFns } from "./Manage-System-Owner.vue?vue&type=template&id=d3968194&"
import script from "./Manage-System-Owner.vue?vue&type=script&lang=js&"
export * from "./Manage-System-Owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports